import React from 'react';
//components
import { ConfirmedOrdersAlertContainer } from './styles';
//interfaces
import { IConfirmedOrdersAlert } from './interface';

export const ConfirmedOrdersAlert: React.FC<IConfirmedOrdersAlert> = (props) => {
  const { distributionCenters, onClick, hasMarginLeft = false } = props;

  return (
    <ConfirmedOrdersAlertContainer onClick={onClick} hasMarginLeft={hasMarginLeft}>
      <span className="alert-text">
        Esta cotação possui pedido resgatado para os CD's: <strong>{distributionCenters}</strong>. Clique aqui para acessar o pedido.
      </span>
    </ConfirmedOrdersAlertContainer>
  );
};


